import { ref } from 'vue';
import { BodyType } from '@/services/BodyType';

export class BodyFormModel {
	public readonly name = ref<string>();
	public readonly type = ref<BodyType>(BodyType.ACCREDITATION_INSTITUTE);
}
